import React, { useEffect, useState } from 'react';
import image1 from '../../assets/images/Carousel3.png';
import image2 from '../../assets/images/Carousel4.png';
import image3 from '../../assets/images/Carousel2.png';
import image4 from '../../assets/images/Carousel1.jpeg';
import playIcon from '../../assets/images/play_icon.svg';
import pauseIcon from '../../assets/images/pause_icon.svg';
import './imageSlider.css'

const ImageSlider = ({ setPlaceholderPrompt }) => {
    const carouselItems = [
        {
            image: image1,
            GeneratedBy: 'Shreya',
            fontName: 'Cooper BT Black Italic',
            prompt: "spicy hot dog cart 'Spicy Dogs'",
            fontUrl: 'bitstream/cooper',
        },
        {
            image: image2,
            GeneratedBy: 'Shreya',
            fontName: 'Commercial Script No2',
            prompt: "Bottle of fragrance brand 'Sia', in the shape of a pear, dark pink...",
            // prompt: "Bottle of fragrance brand 'Sia', in the shape of a pear, dark pink in color, with a golden colored top inspired by the crown of a princess.",
            fontUrl: 'softmaker/commercial-script-no2',
        },
        {
            image: image3,
            GeneratedBy: 'Shreya',
            fontName: 'Hand Of Sean Regular',
            prompt: "Kids Movie Poster Name 'Magic Forest'",
            fontUrl: 'sean-johnson/hand-of-sean-pro',
        },
        {
            image: image4,
            GeneratedBy: 'Shreya',
            fontName: 'Cactus Flower SG Solid',
            prompt: 'Create a forearm sailor tattoo with the words “Fonts Forever”.',
            fontUrl: 'spiece-graphics/cactus-flower-sg',
        },
    ];

    const [activeIndex, setActiveIndex] = useState(0);
    const [isPlaying, setIsPlaying] = useState(true);
    const [isTransitioning, setIsTransitioning] = useState(true);

    useEffect(() => {
        if (carouselItems[activeIndex]) {
            setPlaceholderPrompt(carouselItems[activeIndex].prompt);
        }
    }, [activeIndex, setPlaceholderPrompt]);

    useEffect(() => {
        if (!isPlaying) return;

        const interval = setInterval(() => {
            setActiveIndex((prevIndex) => prevIndex + 1);
        }, 5000);

        return () => clearInterval(interval);
    }, [isPlaying]);

    useEffect(() => {
        if (activeIndex === carouselItems.length) {
            setTimeout(() => {
                setIsTransitioning(false);
                setActiveIndex(0);
            }, 1000);

            setTimeout(() => {
                setIsTransitioning(true);
            }, 1100);
        }
    }, [activeIndex, carouselItems.length]);

    const handlePausePlay = () => setIsPlaying(!isPlaying);

    return (
        <div className="relative md:flex w-auto h-full">
            <div className="flex relative max-w-[200px] sm:max-w-[350px] md:max-w-[600px] xl:max-w-[600px] 2xl:max-w-[700px] overflow-hidden rounded-2xl">
                <div
                    className={`flex ${
                        isTransitioning ? 'transition-transform duration-1000 ease-in-out' : ''
                    }`}
                    style={{
                        transform: `translateX(-${activeIndex * 100}%)`,
                        transition: isTransitioning ? 'transform 1s ease-in-out' : 'none',
                        width: `${(carouselItems.length + 1) * 100}%`,
                    }}
                >
                    {carouselItems.map((item, index) => (
                        <img
                            priority 
                            key={index}
                            src={item.image}
                            className="w-full h-auto object-cover"
                            alt="Carousel"
                            style={{ flex: '0 0 100%' }}
                            />
                        ))}
                    <img
                        src={carouselItems[0].image}
                        className="w-full h-auto object-cover rounded-2xl"
                        alt="Carousel"
                        style={{ flex: '0 0 100%' }}
                    />
                </div>

                <div className="bg-black/20 absolute top-0 z-10 h-full w-full rounded-2xl"></div>
                <div className="absolute z-20 bottom-8 left-1 right-1 flex justify-center items-center text-white">
                    <a
                        className="hover:text-white"
                        href={`https://enterprise.monotype.com/en/family/${carouselItems[activeIndex % carouselItems.length].fontUrl}`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <span className="text-xl font-bold">
                            {carouselItems[activeIndex % carouselItems.length].fontName}
                        </span>
                    </a>
                </div>
            </div>
            <div className="absolute z-30 -bottom-5 left-1 right-1 flex justify-center items-center gap-4">
                <div className="h-10 px-4 rounded-full flex items-center border border-[#DBDFE5] justify-center gap-4 bg-white">
                    {carouselItems.map((_, index) => (
                        <div
                            key={index}
                            className={`h-2 w-2 rounded-full ${
                                index === activeIndex % carouselItems.length
                                    ? 'bg-white ring-2 border-blue-primary'
                                    : 'bg-cus_secondary'
                            }`}
                        ></div>
                    ))}
                </div>
                <div
                    className="rounded-full relative bg-white h-10 w-16 flex items-center justify-center cursor-pointer"
                    onClick={handlePausePlay}
                >
                    <div className="absolute top-1 rounded-full bg-transparent h-9 w-14 ring-2"></div>
                    <img src={isPlaying ? pauseIcon : playIcon} alt="play pause icon" />
                </div>
            </div>
        </div>
    );
};

export default ImageSlider;